import Vue from 'vue'
import Router from 'vue-router'
import Main from '@/components/main'
import PerfectInfo from '@/view/perfectInfo/perfectInfo'

Vue.use(Router)

export const constantRoutes = [
  {
    path: '/login',
    name: '登陆',
    component: () => import('@/view/login/login.vue')
  },
  {
    path: '/register',
    name: '注册',
    component: () => import('@/view/register/register')
  },
  {
    path: '/resetPassword',
    name: '重置密码',
    component: () => import('@/view/resetPassword/resetPassword')
  },
  {
    path: '/bindMobile',
    name: '绑定手机号',
    component: () => import('@/view/bindMobile/bindMobile')
  },
  {
    path: '/404',
    name: '404页面',
    component: Main,
    children: [
      {
        path: '/404',
        name: '页面找不到啦~',
        component: () => import('@/view/errorPage/404'),
        meta: {
          name: '页面丢失'
        }
      }
    ]
  },
  {
    path: '/500',
    name: '500页面',
    component: Main,
    children: [
      {
        path: '/500',
        name: '页面出错啦~',
        component: () => import('@/view/errorPage/500'),
        meta: {
          name: '页面出错'
        }
      }
    ]
  },
  {
    path: '/',
    redirect: '/home',
    component: Main,
    children: [
      {
        path: '/home',
        name: '工作台',
        component: () => import('@/components/home/home.vue'),
        meta: {
          type: '菜单',
          name: '工作台',
          parentMenu: 'home:-'
        }
      },
      {
        path: '/waitting',
        name: '待开发',
        component: () => import('@/view/waitting/waitting.vue')
      }
    ]
  },
  {
    path: '/',
    name: '完善资料',
    component: PerfectInfo,
    children: [
      {
        path: '/perfectInfo',
        name: '完善资料-请选择',
        component: () => import('@/view/perfectInfo/infoChoose.vue')
      },
      {
        path: '/perfectInfo/lawyer',
        name: '完善资料-律师团队',
        component: () => import('@/view/perfectInfo/lawyerInfo.vue')
      },
      {
        path: '/changeInfo',
        name: '修改个人资料',
        component: () => import('@/view/perfectInfo/changeInfo')
      }
    ]
  },
  {
    path: '/',
    name: '个人中心',
    component: Main,
    children: [
      {
        path: '/personalCenter/information',
        name: '账号管理',
        component: () => import('@/view/personalCenter/information.vue')
      }
    ]
  }
]

export const asyncRoutes = [
  {
    path: '/',
    name: '成员管理',
    component: Main,
    children: [
      {
        path: '/memberManage/memberManage',
        name: '成员管理',
        component: () => import('@/view/memberManage/memberManage.vue'),
        meta: {
          type: '菜单',
          name: '成员管理',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/memberManage/memberGroupManage',
        name: '成员组管理',
        component: () => import('@/view/memberManage/memberGroupManage.vue'),
        meta: {
          type: '菜单',
          name: '成员组管理',
          parentMenu: 'system:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '任务大厅',
    component: Main,
    children: [
      {
        path: '/taskHall/publicTask',
        name: '公共任务',
        component: () => import('@/view/taskHall/publicTask/publicTask.vue'),
        meta: {
          type: '菜单',
          name: '公共任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/designateTask',
        name: '指派任务',
        component: () => import('@/view/taskHall/designateTask/designateTask.vue'),
        meta: {
          type: '菜单',
          name: '指派任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/myTask',
        name: '我的任务',
        component: () => import('@/view/taskHall/myTask/myTask.vue'),
        meta: {
          type: '菜单',
          name: '我的任务',
          parentMenu: 'mission:-'
        }
      },
      {
        path: '/taskHall/allTasks',
        name: '已接受任务',
        component: () => import('@/view/taskHall/allTasks/allTasks.vue'),
        meta: {
          type: '菜单',
          name: '已接受任务',
          parentMenu: 'mission:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '举报线索',
    component: Main,
    children: [
      {
        path: '/clue/verify',
        name: '线索核实',
        component: () => import('@/view/clue/verifyClue/index.vue'),
        meta: {
          type: '菜单',
          name: '线索核实',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/all',
        name: '全部线索',
        component: () => import('@/view/clue/allMyClue/index.vue'),
        meta: {
          type: '菜单',
          name: '全部线索',
          parentMenu: 'clue:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '线索',
    component: Main,
    children: [
      {
        path: '/clue/myClue',
        name: '我的线索',
        component: () => import('@/view/clue/myClue/myClue.vue'),
        meta: {
          type: '菜单',
          name: '我的线索',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/allClues',
        name: '全部线索',
        component: () => import('@/view/clue/allClues/allClues.vue'),
        meta: {
          type: '菜单',
          name: '全部线索',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/toPurchasedClues',
        name: '待测购',
        component: () => import('@/view/clue/allClues/toPurchasedClues.vue'),
        meta: {
          type: '菜单',
          name: '待测购',
          parentMenu: 'clue:-'
        }
      },
      {
        path: '/clue/AllToPurchasedClues',
        name: '全部待测购',
        component: () => import('@/view/clue/allClues/AllToPurchasedClues.vue'),
        meta: {
          type: '菜单',
          name: '全部待测购',
          parentMenu: 'clue:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '待办跟催',
    component: Main,
    children: [
      {
        path: '/case/followUp',
        name: '待办跟催',
        component: () => import('@/view/followUp/index.vue'),
        meta: {
          type: '菜单',
          name: '待办跟催',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '案件',
    component: Main,
    children: [
      {
        path: '/case/allocatedCase',
        name: '待分配的',
        component: () => import('@/view/case/allocatedCase.vue'),
        meta: {
          type: '菜单',
          name: '待分配的',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/allCases',
        name: '全部案件',
        component: () => import('@/view/case/allCases.vue'),
        meta: {
          type: '菜单',
          name: '全部案件',
          parentMenu: 'case:-'
        }
      }

    ]
  },
  {
    path: '/',
    name: '民事案件',
    component: Main,
    children: [
      {
        path: '/case/civilCase',
        name: '普通案件',
        component: () => import('@/view/case/civilCase.vue'),
        meta: {
          type: '菜单',
          name: '普通案件',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/obtainEvidenceCase',
        name: '取证案件',
        component: () => import('@/view/case/obtainEvidenceCase.vue'),
        meta: {
          type: '菜单',
          name: '取证案件',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/seriousCase',
        name: '重案案件',
        component: () => import('@/view/case/seriousCase.vue'),
        meta: {
          type: '菜单',
          name: '重案案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '我的案件',
    component: Main,
    children: [
      {
        path: '/case/ongoingMyCase',
        name: '我的案件-进行中',
        component: () => import('@/view/case/myCase/ongoingMyCase.vue'),
        meta: {
          type: '菜单',
          name: '我的案件-进行中',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/allMyCase',
        name: '我的案件-全部',
        component: () => import('@/view/case/myCase/allMyCase.vue'),
        meta: {
          type: '菜单',
          name: '我的案件-全部',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/fxNotary',
        name: '法信固证信息',
        component: () => import('@/view/case/fxNotary.vue'),
        meta: {
          type: '菜单',
          name: '法信固证信息',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '我的重案',
    component: Main,
    children: [
      {
        path: '/case/ongoingMySeriousCase',
        name: '我的重案-进行中',
        component: () => import('@/view/case/mySeriousCase/ongoingMySeriousCase.vue'),
        meta: {
          type: '菜单',
          name: '我的重案-进行中',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/allMySeriousCase',
        name: '我的重案-全部',
        component: () => import('@/view/case/mySeriousCase/allMySeriousCase.vue'),
        meta: {
          type: '菜单',
          name: '我的重案-全部',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '诉讼方案管理',
    component: Main,
    children: [
      {
        path: '/actionPlan/unSubmitted',
        name: '未提交(已配置模板)',
        component: () => import('@/view/actionPlan/unSubmitted/index.vue'),
        meta: {
          type: '菜单',
          name: '未提交方案',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/actionPlan/templateConfig',
        name: '(未提交)未配置模板',
        component: () => import('@/view/actionPlan/templateConfig/index.vue'),
        meta: {
          type: '菜单',
          name: '未配置模板',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/actionPlan/submitted',
        name: '已提交方案',
        component: () => import('@/view/actionPlan/submitted/index.vue'),
        meta: {
          type: '菜单',
          name: '已提交方案',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/actionPlan/reject',
        name: '已驳回',
        component: () => import('@/view/actionPlan/reject/index.vue'),
        meta: {
          type: '菜单',
          name: '已驳回',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/actionPlan/partyAnomaly',
        name: '当事人异常',
        component: () => import('@/view/actionPlan/partyAnomaly/index.vue'),
        meta: {
          type: '菜单',
          name: '当事人异常',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/material/newMaterialList',
        name: '材料清单',
        component: () => import('@/view/newMaterialList/newMaterialList.vue'),
        meta: {
          type: '菜单',
          name: '材料清单',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/material/court',
        name: '开庭材料管理',
        component: () => import('@/view/newMaterialList/courtMaterialsList.vue'),
        meta: {
          type: '菜单',
          name: '开庭材料管理',
          parentMenu: 'case:program:-'
        }
      }

    ]
  },
  {
    path: '/',
    name: '异常当事人管理',
    component: Main,
    children: [
      {
        path: '/partyManagement/incompleteInformation',
        name: '主体信息不完整',
        component: () => import('@/view/partyManagement/incompleteInformation/index.vue'),
        meta: {
          type: '菜单',
          name: '主体信息不完整',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/partyManagement/principalFailure',
        name: '主体疑似失效',
        component: () => import('@/view/partyManagement/principalFailure/index.vue'),
        meta: {
          type: '菜单',
          name: '主体疑似失效',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/partyManagement/conflictCorrelation',
        name: '冲突关联待确定/驳回',
        component: () => import('@/view/partyManagement/conflictCorrelation/index.vue'),
        meta: {
          type: '菜单',
          name: '冲突关联待确定/驳回',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/partyManagement/subjectDisclosure',
        name: '主体待披露',
        component: () => import('@/view/partyManagement/subjectDisclosure/index.vue'),
        meta: {
          type: '菜单',
          name: '主体待披露',
          parentMenu: 'case:program:-'
        }
      }

    ]
  },
  {
    path: '/',
    name: '执行材料管理',
    component: Main,
    children: [
      {
        path: '/carryoutMaterialManage/unSubmited',
        name: '未提交',
        component: () => import('@/view/carryoutMaterialManage/unSubmited.vue'),
        meta: {
          type: '菜单',
          name: '未提交',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/carryoutMaterialManage/submited',
        name: '已提交',
        component: () => import('@/view/carryoutMaterialManage/submited.vue'),
        meta: {
          type: '菜单',
          name: '已提交',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/carryoutMaterialManage/expired',
        name: '已过执行申请时效',
        component: () => import('@/view/carryoutMaterialManage/expired.vue'),
        meta: {
          type: '菜单',
          name: '已过执行申请时效',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/carryoutMaterialManage/rejectMaterial',
        name: '已驳回',
        component: () => import('@/view/carryoutMaterialManage/rejectMaterial.vue'),
        meta: {
          type: '菜单',
          name: '已驳回',
          parentMenu: 'case:program:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '盖章材料管理',
    component: Main,
    children: [
      {
        path: '/carryoutMaterialManage/otherMaterial',
        name: '其它盖章材料申请',
        component: () => import('@/view/carryoutMaterialManage/otherMaterial.vue'),
        meta: {
          type: '菜单',
          name: '其它盖章材料申请',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/carryoutMaterialManage/refundMaterial',
        name: '领款&退费材料管理',
        component: () => import('@/view/carryoutMaterialManage/refundMaterial.vue'),
        meta: {
          type: '菜单',
          name: '领款&退费材料管理',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/carryoutMaterialManage/appealMaterial',
        name: '上诉&再审材料管理',
        component: () => import('@/view/carryoutMaterialManage/appealMaterial.vue'),
        meta: {
          type: '菜单',
          name: '上诉&再审材料管理',
          parentMenu: 'case:program:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '立案进程管理',
    component: Main,
    children: [
      {
        path: '/filingProcess/toBeGenerated',
        name: '待生成',
        component: () => import('@/view/filingProcess/toBeGenerated/index.vue'),
        meta: {
          type: '菜单',
          name: '待生成',
          parentMenu: 'case:program:-'
        }
      },
      {
        path: '/filingProcess/generated',
        name: '已生成',
        component: () => import('@/view/filingProcess/generated/index.vue'),
        meta: {
          type: '菜单',
          name: '已生成',
          parentMenu: 'case:program:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '行政案件',
    component: Main,
    children: [
      {
        path: '/case/administrativeCase',
        name: '行政案件',
        component: () => import('@/view/case/administrativeCase.vue'),
        meta: {
          type: '菜单',
          name: '行政案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '刑事案件',
    component: Main,
    children: [
      {
        path: '/case/criminalCase',
        name: '刑事案件',
        component: () => import('@/view/case/criminalCase.vue'),
        meta: {
          type: '菜单',
          name: '刑事案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '已转出案件',
    component: Main,
    children: [
      {
        path: '/case/transferredCases',
        name: '已转出案件',
        component: () => import('@/view/case/transferredCases.vue'),
        meta: {
          type: '菜单',
          name: '已转出案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '案件管理助手',
    component: Main,
    children: [
      {
        path: '/case/batchProcess',
        name: '案件信息批量处理',
        component: () => import('@/view/caseAssistant/caseBatch/index.vue'),
        meta: {
          type: '菜单',
          name: '案件信息批量处理',
          parentMenu: 'case:-'
        }
      },
      {
        path: '/case/pushedNotaryOffice',
        name: '已推送公证处案件',
        component: () => import('@/view/caseAssistant/pushedNotaryOffice/index.vue'),
        meta: {
          type: '菜单',
          name: '已推送公证处案件',
          parentMenu: 'case:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '项目管理',
    component: Main,
    children: [
      {
        path: '/project/list',
        name: '项目管理',
        component: () => import('@/view/project/project.vue'),
        meta: {
          type: '菜单',
          name: '项目管理',
          parentMenu: 'project:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '系统设置',
    component: Main,
    children: [
      {
        path: '/settings/teamInfo',
        name: '团队信息',
        component: () => import('@/view/settings/teamInfo.vue'),
        meta: {
          type: '菜单',
          name: '团队信息',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/authority',
        name: '权限管理',
        component: () => import('@/view/settings/authority.vue'),
        meta: {
          type: '菜单',
          name: '权限管理',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/bankCardAccount',
        name: '银行卡账户',
        component: () => import('@/view/settings/bankCardAccount.vue'),
        meta: {
          type: '菜单',
          name: '银行卡账户',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/mailingAddress',
        name: '邮寄地址',
        component: () => import('@/view/settings/mailingAddress.vue'),
        meta: {
          type: '菜单',
          name: '邮寄地址',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/orgChange',
        name: '机构变更',
        component: () => import('@/view/settings/orgChange.vue'),
        meta: {
          type: '菜单',
          name: '机构变更',
          parentMenu: 'system:-'
        }
      },
      {
        path: '/settings/noticeBank',
        name: '公告栏',
        component: () => import('@/view/settings/noticeBank.vue'),
        meta: {
          type: '菜单',
          name: '公告栏',
          parentMenu: 'system:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '案件预约',
    component: Main,
    children: [
      {
        path: '/tradingCenter/publicPackage',
        name: '公共包',
        component: () => import('@/view/tradingCenter/casePackage/publicPackage.vue'),
        meta: {
          type: '菜单',
          name: '公共包',
          parentMenu: 'trade-center:-'
        }
      },
      {
        path: '/tradingCenter/assignPackage',
        name: '指派包',
        component: () => import('@/view/tradingCenter/casePackage/assignPackage.vue'),
        meta: {
          type: '菜单',
          name: '指派包',
          parentMenu: 'trade-center:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '交易中心',
    component: Main,
    children: [
      {
        path: '/tradingCenter/myOrder',
        name: '我的订单',
        component: () => import('@/view/tradingCenter/orderManage/myOrder.vue'),
        meta: {
          type: '菜单',
          name: '我的订单',
          parentMenu: 'trade-center:-'
        }
      },
      {
        path: '/tradingCenter/additionalOrder',
        name: '附加订单',
        component: () => import('@/view/tradingCenter/orderManage/additionalOrder.vue'),
        meta: {
          type: '菜单',
          name: '附加订单',
          parentMenu: 'trade-center:-'
        }
      },
      {
        path: '/tradingCenter/return',
        name: '退案管理',
        component: () => import('@/view/tradingCenter/returnManage/return.vue'),
        meta: {
          type: '菜单',
          name: '退案管理',
          parentMenu: 'trade-center:-'
        }
      },
      {
        path: '/tradingCenter/mailingList',
        name: '邮寄列表',
        component: () => import('@/view/tradingCenter/mailingList/index.vue'),
        meta: {
          type: '菜单',
          name: '邮寄列表',
          parentMenu: 'trade-center:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '民事结算管理',
    component: Main,
    children: [
      {
        path: '/settlementCenter/caseToBeSettled',
        name: '待结算案件',
        component: () => import('@/view/settlementCenter/caseToBeSettled.vue'),
        meta: {
          type: '菜单',
          name: '待结算案件',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlementCenter/settlementManage',
        name: '结算管理',
        component: () => import('@/view/settlementCenter/settlementManage.vue'),
        meta: {
          type: '菜单',
          name: '结算管理',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/settlementCenter/collectionRecord',
        name: '收款记录',
        component: () => import('@/view/settlementCenter/collectionRecord.vue'),
        meta: {
          type: '菜单',
          name: '收款记录',
          parentMenu: 'settlement:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '报酬结算管理',
    component: Main,
    children: [
      {
        path: '/reward/settlement/unsettledCase',
        name: '待结算案件',
        component: () => import('@/view/rewardStatement/unsettledCase/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-待结算案件',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/reward/settlement/statementManagement',
        name: '结算单管理',
        component: () => import('@/view/rewardStatement/statementManagement/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-结算单管理',
          parentMenu: 'settlement:-'
        }
      },
      {
        path: '/reward/settlement/collectionRecord',
        name: '收款记录',
        component: () => import('@/view/rewardStatement/collectionRecord/index.vue'),
        meta: {
          type: '菜单',
          name: '报酬-收款记录',
          parentMenu: 'settlement:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '权属查询',
    component: Main,
    children: [
      {
        path: '/tools/trademark',
        name: '商标查询',
        component: () => import('@/view/tools/trademark/index.vue'),
        meta: {
          type: '菜单',
          name: '商标查询',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/zhihuiya',
        name: '专利查询',
        component: () => import('@/view/tools/zhihuiya/index.vue'),
        meta: {
          type: '菜单',
          name: '专利查询',
          parentMenu: 'tools:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '侵权监测',
    component: Main,
    children: [
      {
        path: '/tools/infringementMonitoring/oldOnlineMonitor',
        name: '线上监测（旧版）',
        component: () => import('@/view/tools/infringementMonitoring/onlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线上监测（旧版）',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/infringementMonitoring/onlineMonitor',
        name: '线上监测',
        component: () => import('@/view/tools/infringementMonitoring/newOnlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线上监测',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/infringementMonitoring/offlineMonitor',
        name: '线下监测',
        component: () => import('@/view/tools/infringementMonitoring/offlineMonitor/index.vue'),
        meta: {
          type: '菜单',
          name: '线下监测',
          parentMenu: 'tools:-'
        }
      }
    ]
  },

  {
    path: '/',
    name: '工具',
    component: Main,
    children: [
      {
        path: '/tools/fatianshi',
        name: '合同助手',
        component: () => import('@/view/tools/fatianshi/index.vue'),
        meta: {
          type: '菜单',
          name: '合同助手',
          parentMenu: 'tools:-'
        }
      },
      {
        path: '/tools/legal',
        name: '法律工具',
        component: () => import('@/view/tools/legal/index.vue'),
        meta: {
          type: '菜单',
          name: '法律工具',
          parentMenu: 'tools:-'
        }
      }
    ]
  },

  {
    path: '/tools/fatianshi/result',
    name: '过滤列表',
    component: () =>
      import('@/view/tools/fatianshi/result.vue')
  },
  {
    path: '/tools/fatianshi/preview',
    name: '预览',
    component: () =>
      import('@/view/tools/fatianshi/preview.vue')
  },
  {
    path: '/tools/fatianshi/edit',
    name: '编辑',
    component: () =>
      import('@/view/tools/fatianshi/edit.vue')
  },
  {
    path: '/',
    name: '待推送案件',
    component: Main,
    children: [
      {
        path: '/mediationCenter/propellingCase',
        name: '待推送案件',
        component: () => import('@/view/mediationCenter/propellingCase/index.vue'),
        meta: {
          type: '菜单',
          name: '待推送案件',
          parentMenu: 'mediation-center:-'
        }
      }
    ]
  },
  {
    path: '/',
    name: '已推送案件',
    component: Main,
    children: [
      {
        path: '/mediationCenter/mediationCase',
        name: '已推送案件',
        component: () => import('@/view/mediationCenter/mediationCase/index.vue'),
        meta: {
          type: '菜单',
          name: '已推送案件',
          parentMenu: 'mediation-center:-'
        }
      }
    ]
  }
]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router



// WEBPACK FOOTER //
// ./src/router/index.js